import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { socialConnectionsKeys } from '@/api/queryKeys';
import type { SocialProvider } from '@/api/queries/settings';

/**
 * Hook to disconnect a social provider.
 * This mirrors the mobile app's deleteSocialConnection mutation.
 */
export function useDisconnectSocialProvider() {
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn: (api) => async (provider: SocialProvider) => {
      await api.settings.settingsControllerDeleteSocialConnection(provider);
    },
    onSuccess: () => {
      // Invalidate social connections to refetch
      queryClient.invalidateQueries({
        queryKey: socialConnectionsKeys.list(),
      });
    },
  });
}
